import React from 'react';

import { Modal } from 'src/components/common';
import { TestVerificationRequestPdfPreviewModalForm } from 'src/components/testVerificationRequest/TestVerificationRequestPdfPreivewModalForm';
import { ModalId } from 'src/constants/modals';
import { useModal } from 'src/hooks/shared';

import { TestVerificationRequestPdfPreviewModalArgs } from './types';

export const TestVerificationRequestPdfPreviewModal: React.FC = () => {
  const { closeModal, isOpen, args } = useModal<TestVerificationRequestPdfPreviewModalArgs>(
    ModalId.TestVerificationRequestPdfPreviewModal,
  );

  const handleCloseModal = React.useCallback(() => {
    closeModal();
  }, [closeModal]);

  return (
    <Modal
      title={args?.generatedReportFile?.filename || 'Unnamed file'}
      dialogProps={{
        onClose: handleCloseModal,
        open: isOpen,
      }}
      maxWidth={691}
    >
      <TestVerificationRequestPdfPreviewModalForm
        generatedReport={args?.generatedReportFile}
        closeModal={handleCloseModal}
      />
    </Modal>
  );
};
